module.exports = __webpack_public_path__ + "static/fillingbottles-306c306ef516743be8c4f1caf551ec4d.jpg";